import { useState, useEffect } from "react";
import { getShifts } from "../../api/ShiftsApi";
import { Plantao } from "../../models/Plantao";
import { ShiftStatus } from "../../types/shiftStatus";
import { ShiftMode } from "../../types/shiftMode";

type Modalidade = "online" | "presencial";

type UsePlantoesParams = {
  modalidade: Modalidade;
  placeId?: string;
};

type UsePlantoesResult = {
  plantoes: Plantao[];
  isLoading: boolean;
};

export default function usePlantoes({ modalidade, placeId }: UsePlantoesParams): UsePlantoesResult {
  const [plantoes, setPlantoes] = useState<Plantao[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    let cancelled = false;

    async function fetchPlantoes() {
      setIsLoading(true);
      try {
        const shiftMode = modalidade === "presencial" ? ShiftMode.Presential : ShiftMode.Online;
        const generatedPlantoes = await getShifts(
          [ShiftStatus.OPEN, ShiftStatus.PRE_OPEN],
          shiftMode,
          placeId
        );
        if (cancelled) return;
        setPlantoes(generatedPlantoes as Plantao[]);
      } catch (error) {
        console.error("Erro ao carregar plantões:", error);
        if (cancelled) return;
        setPlantoes([]);
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    }

    fetchPlantoes();

    return () => {
      cancelled = true;
    };
  }, [modalidade, placeId]);

  return { plantoes, isLoading };
}
